module.exports = __webpack_public_path__ + "img/home.d6e96542.jpeg";